import { Toaster } from "components/notification/Toaster";
import { useCustomSelector } from "hooks";
import { useEffect, useState } from "react";


export default function useFilters(currentTabId) {
    const [comId, setComId] = useState();
    const [accountCode, setAccountCode] = useState("");
    const [companyName, setCompanyName] = useState();

    const [isFiltering, setIsFiltering] = useState();

    const { getAllOutlets_requesting } = useCustomSelector("outlet");

    function onFilterSubmit(setFilterOptions, filterOptions = {}, isReset, inputFilters = {}) {
        if (isReset) {
            setFilterOptions(filterOptions);
            setComId("");
            setAccountCode("");
            setCompanyName("");
        }
        else {
            let comId_input = inputFilters?.comId;
            let accountCode_input = inputFilters?.accountCode;

            let comId_forValidation = comId_input ? comId_input : comId;
            let accountCode_forValidation = accountCode_input ? accountCode_input : accountCode;

            if (!comId_forValidation && !accountCode_forValidation) {
                Toaster({
                    type: "info",
                    msg: "Please fill in COM ID or Account Code"
                });
                return;
            }

            let comId_forApi = comId_forValidation ? (comId_forValidation + "").trim() : 0;
            let accountCode_forApi = (accountCode_forValidation + "").trim();

            setIsFiltering(true);
            setFilterOptions({
                ...filterOptions,
                comId: comId_forApi,
                accountCode: accountCode_forApi,
                companyName
            })
        }
    }

    useEffect(() => {
        if (!getAllOutlets_requesting) setIsFiltering(false);
    }, [getAllOutlets_requesting]);
    
    return {
        companyName, setCompanyName,
        comId, setComId,
        accountCode, setAccountCode,

        isFiltering, onFilterSubmit,
    }
}